import React, { useState } from "react";
import "./About.css";
import { NavLink} from "react-router-dom";
const members = [
  {
    name: "Walter Dzvairo",
    role: "Founder",
    image:
      "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/walter-high.jpg?enable-io=true&crop=1%3A1&width=226",
  },
  {
    name: "Gurvinder Singh",
    role: "Business Partner",
    image:
      "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/gurvinder-high.jpg?enable-io=true&crop=1%3A1&width=226",
  },
  {
    name: "Simon Kett",
    role: "Business Development ",
    image:
      "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/simon-standard.png?enable-io=true&crop=1%3A1&width=226",
  },
  {
    name: "David Hutchison",
    role: "Business Development ",
    image:
      "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/david-high.jpg?enable-io=true&crop=1%3A1&width=226",
  },
  {
    name: "Kieran Bloom",
    role: "Capital Allowances",
    image:
      "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/kieran-high.jpg?enable-io=true&crop=1%3A1&width=226",
  },
  {
    name: "Ebony Fletcher",
    role: "Recruitment",
    image:
      "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/ebony-high.jpg?enable-io=true&crop=1%3A1&width=226",
  },
];

const OurTeam = () => {
  const [active, setActive] = useState(0);

  const nextSlide = () => {
    setActive((prev) => (prev + 1) % members.length);
  };

  const prevSlide = () => {
    setActive((prev) => (prev - 1 + members.length) % members.length);
  };

  return (
    <>
    <section className="team-section">
      <h1 className="about-title">MEET OUR TEAM</h1>
      <p className="About-Pera">Behind every service we provide is a dedicated team of professionals,each bringing their unique expertise <br/>  and enthusiasm to our business.</p>
      <div className="carousel-container">
        <button className="nav-arrow left" onClick={prevSlide}>
          ‹
        </button>
        <div className="carousel-track">
          {members.map((member, index) => {
            let position = index - active;
            if (position < -2) position += members.length;
            if (position > 2) position -= members.length;
            return (
              <div
                key={index}
                className={`Our_card ${index === active ? "active" : ""}`}
                style={{
                  transform: `translateX(${position * 220}px)
                              scale(${index === active ? 1 : 0.8})
                              rotateY(${position * -25}deg)`,
                  opacity: Math.abs(position) > 2 ? 0 : 1,
                  zIndex: 10 - Math.abs(position),
                }}>
                <img src={member.image} alt={member.name} draggable="false" />
              </div>
            );
          })}
        </div>

        <button className="nav-arrow right" onClick={nextSlide}>
          ›
        </button>
      </div>
      <div className="member-info">
        <h2 className="member-name">{members[active].name}</h2>
        <p className="member-role">{members[active].role}</p>
      </div>
    </section>
    <section className="Ab-Heading">
     <h1 className="Ab-title">"Total Care Advisory's guidance was invaluable. Their  practical experiences  <br />truly made a difference in navigating CQC regulations and optimising our service." </h1>
     <p className="Ab-peragraph">Stephen R, Home Care Director, Bristol.</p>
      <button className="OurServices-btn">
          <NavLink to="/insights">
          Read More
        </NavLink>
      </button>
    </section>
    
    </>
  );
};

export default OurTeam;